import {Component, ElementRef, EventEmitter, inject, Input, Output, ViewChild} from '@angular/core';
import {MenuOption} from "../main-layout/menu-option";
import {Router} from "@angular/router";

@Component({
  selector: 'app-top-nav-right-bar',
  templateUrl: './top-nav-right-bar.component.html',
  styleUrl: './top-nav-right-bar.component.scss'
})
export class TopNavRightBarComponent {
  isOpen = false;
  @Input() menuItems: MenuOption[] = [];
  @Output() sideBarOpened = new EventEmitter<boolean>();
  expandedMenu: string = null
  currentMenu: any;
  @ViewChild('navigationRef') navigationRef: ElementRef;
  router = inject(Router);


  toggleSidebar() {
    this.isOpen = !this.isOpen;
    this.sideBarOpened.emit(this.isOpen);
  }

  changeOpenedMenu(isOpen: boolean, menuName: string) {
    this.expandedMenu = isOpen ? menuName : null
  }

  isActiveRoute(route: String[]) {
    let url = this.router.url?.split('/')
    url?.splice(0, 2)
    return route.join('').includes(url?.join('/'))
  }


  async onMenuClick() {
    // let isMobile = await firstValueFrom(this.isHandset$.pipe(first()));
    // if (isMobile) {
    //   await drawer.toggle();
    // }
  }

}
